const experiencesAr = [
  {
    title: "رئيس قطاع التكنولوجيا والحلول للمجموعة (Group CTO & CSO)",
    company: "مركز الخدمات المشتركة: Click2Secure، Payd، Starz TPA، Seguro، Trustcare",
    period: "ديسمبر 2025 إلى الآن",
    location: "عن بُعد",
    description:
      "إدارة وقيادة مركز تكنولوجي مشترك يوفر التوجيه التقني، واستراتيجية الأمن السيبراني، والتميز التشغيلي عبر كيانات المجموعة. قيادة المعالجة التقنية لشركة Payd لتحقيق الامتثال الشامل لمعيار PCI DSS v4.0.1 كمزود خدمة؛ والإشراف على نيل شهادة ISO 27001:2022؛ وقيادة برنامج الامتثال لمعايير ADHICS المعتمدة من دائرة الصحة بأبوظبي؛ وأتمتة ضوابط فحص غسل الأموال (AML/CTF). توجيه بناء محرك بوابة الدفع بلغة Rust و Laravel، وتصميم بنى التعافي السحابي (AWS/Azure)، وحماية محيط الشبكات وتأمين التطبيقات بدفاعات عميقة (CrowdSec، Suricata IDS/IPS، جدران حماية OPNsense و pfSense، قواعد OWASP CRS، وجدران الحماية السحابية AWS WAF & Network Firewall و Azure Firewall & WAF)، والنجاح في إنجاز النسخ الاحتياطي والترحيل الطارئ بصفر فقدان في البيانات خلال أزمة هجوم سحابة AWS في الإمارات تحت أقصى درجات الضغط والتشغيل.",
    skills: [
      "معيار PCI DSS v4.0.1",
      "شهادة ISO 27001:2022",
      "معايير ADHICS و DOH",
      "منظومات CrowdSec و Suricata (IDS/IPS)",
      "جدران حماية AWS و Azure WAF",
      "قواعد OWASP CRS و ModSecurity",
      "جدران حماية OPNsense و pfSense",
      "لغة Rust (Actix-web)",
      "لغة PHP (Laravel)",
      "بوابات الدفع الإلكتروني",
      "التعافي من الكوارث والترحيل الطارئ",
      "Wazuh (HIPS/IDS)",
      "فحص الامتثال الآلي AML/CTF",
      "قيادة مركز الموارد المشتركة"
    ],
  },
  {
    title: "الرئيس التنفيذي للتكنولوجيا (CTO)",
    company: "غلوبال فنتشرز الإمارات (PAYD مدفوع و CLICK2SECURE)",
    period: "يناير 2025 إلى ديسمبر 2025",
    location: "عن بُعد",
    description:
      "تحديث البنية التحتية للمدفوعات، وتأسيس معايير صارمة لجودة الشيفرة البرمجية وأمن المعلومات، وتنفيذ التكاملات التقنية الحيوية لشركاء B2B عبر محفظة التقنية المالية. قيادة دمج أدوات المراقبة اللحظية وعمليات الأمان SOC، وأتمتة مسارات النشر السحابي وشهادات امتثال الشركاء (AOC/ROC).",
    skills: [
      "بنية التقنية المالية",
      "معمارية الأنظمة",
      "تكامل منصات B2B",
      "عمليات الأمان السيبراني",
      "DevOps و CI/CD",
      "الهندسة السحابية"
    ],
  },
  {
    title: "رئيس قسم تكنولوجيا المعلومات (Head of IT)",
    company: "PAYD مدفوع و CLICK2SECURE",
    period: "أغسطس 2024 إلى يناير 2025",
    location: "هجين",
    description:
      "قيادة قسم تقنية المعلومات والإشراف على البنية التحتية الأساسية، ومعايير الأمان المؤسسي، وشبكات الاتصال، والأنظمة الرقمية. تطبيق ضوابط الأمان على مستوى الخوادم، والمراقبة المركزية للأخطاء، وتنسيق أعمال التدقيق التقني.",
    skills: [
      "البنية التحتية لتكنولوجيا المعلومات",
      "أمن الشبكات",
      "العمليات السحابية",
      "تحصين الأنظمة",
      "الامتثال والتدقيق"
    ],
  },
  {
    title: "مهندس برمجيات (دوام جزئي)",
    company: "PAYD مدفوع",
    period: "مارس 2024 إلى مارس 2025",
    location: "عن بُعد",
    description:
      "قيادة التطوير الشامل وتحديث منصة الويب للتجار والعملاء في PAYD. بناء واجهة مستخدم تفاعلية آمنة وعالية الأداء ومتجاوبة بالكامل وربطها ببروتوكولات API قوية متوافقة مع متطلبات الامتثال المالي الصارمة.",
    skills: [
      "React",
      "JavaScript / TypeScript",
      "واجهات REST APIs",
      "معمارية الويب الحديثة",
      "هندسة واجهات المستخدم"
    ],
  },
  {
    title: "مهندس برمجيات (Software Engineer)",
    company: "واد كنيس / Ouedkniss",
    period: "فبراير 2022 إلى أغسطس 2024",
    location: "القبة، الجزائر العاصمة، الجزائر",
    description:
      "تطوير خدمات الويب للأنظمة عالية الحركة لأكبر سوق رقمي في الجزائر يخدم ملايين المستخدمين شهرياً. تحسين مسارات البحث والتصفح الحيوية وتخفيض زمن الاستجابة، وتطوير خدمات مصغرة قابلة للتوسع باستخدام TypeScript وأحدث تقنيات الويب.",
    skills: [
      "لغة TypeScript",
      "الأنظمة عالية الحركة والضغط",
      "تحسين الأداء وسرعة الاستجابة",
      "الخدمات المصغرة",
      "واجهات ويب قابلة للتوسع"
    ],
  },
  {
    title: "مطور شامل ومهندس حلول (Full-Stack Architect)",
    company: "عمل حر واستشارات تقنية",
    period: "يناير 2014 إلى مارس 2022",
    location: "عن بُعد",
    description:
      "تصميم وتطوير منصات ويب مخصصة ومحركات تجارة إلكترونية وحلول برمجية عالية الأداء لعملاء محليين ودوليين في قطاعات متعددة. هندسة قواعد بيانات متقدمة، وبناء خوادم API عالية الكفاءة، وواجهات مستخدم سريعة.",
    skills: [
      "التطوير الشامل Full-Stack",
      "Next.js و React",
      "لغة PHP و Laravel",
      "معمارية قواعد البيانات",
      "تصميم وهندسة الأنظمة"
    ],
  },
  {
    title: "مصمم واجهات وتجربة مستخدم (UI/UX Designer)",
    company: "عمل حر",
    period: "يونيو 2013 إلى مارس 2022",
    location: "عن بُعد",
    description:
      "تصميم واجهات رقمية تتمحور حول المستخدم، وأنظمة تصميم شاملة، ومسارات تجربة مستخدم متناسقة لتطبيقات الويب والمحمول، وبناء أسس متينة في التسلسل الهرمي البصري وسهولة الوصول التي عززت القيادة التقنية للمنتجات.",
    skills: [
      "تصميم تجربة المستخدم UI/UX",
      "أنظمة التصميم (Design Systems)",
      "مخططات ومسارات المستخدم",
      "سهولة الوصول (Accessibility)",
      "برامج Affinity"
    ],
  },
];

export default experiencesAr;
